import { render, staticRenderFns } from "./ManageMeasures.vue?vue&type=template&id=61e59f28&"
import script from "./ManageMeasures.vue?vue&type=script&lang=js&"
export * from "./ManageMeasures.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports